import React, { useState } from "react";
import { MessageCircle, Mail, X, Plus } from "lucide-react";
import { CONTACT } from "../lib/brand";

export const FloatingContact = () => {
  const [open, setOpen] = useState(false);

  const items = [
    {
      label: "WhatsApp",
      href: `https://wa.me/${CONTACT.whatsapp.replace(/[^0-9]/g, "")}`,
      icon: MessageCircle,
      testid: "floating-whatsapp",
      bg: "bg-[#25D366]",
    },
    {
      label: "Email",
      href: `mailto:${CONTACT.email}`,
      icon: Mail,
      testid: "floating-email",
      bg: "bg-[#20282c] text-white",
    },
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3" data-testid="floating-contact">
      {open &&
        items.map((it) => {
          const Icon = it.icon;
          return (
            <a
              key={it.label}
              href={it.href}
              target={it.label === "WhatsApp" ? "_blank" : undefined}
              rel="noopener noreferrer"
              data-testid={it.testid}
              className={`flex items-center gap-3 rounded-md pl-4 pr-5 py-3 ${it.bg} text-sm font-display font-bold uppercase tracking-wider shadow-2xl hover:brightness-110 transition fade-up`}
            >
              <Icon size={18} />
              <span>{it.label}</span>
            </a>
          );
        })}

      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Close contact options" : "Open contact options"}
        data-testid="floating-toggle"
        className="h-14 w-14 rounded-full bg-[#f28a16] text-white flex items-center justify-center shadow-2xl hover:brightness-110 transition"
      >
        {open ? <X size={22} /> : <Plus size={22} />}
      </button>
    </div>
  );
};

export default FloatingContact;
